export default __webpack_public_path__ + "static/media/banner-06_980x700_crop_center.f094490a.jpg";